import httpClient from "../httpClient";
import { API_CLOSE_FLAG_CASE } from "../config";

const closeflagCase = {
    close: (id) => httpClient.get(API_CLOSE_FLAG_CASE + '/' + id),
};

export default closeflagCase;
